/**
 * Accordion expand/collapse decision for SignalSourceTree.
 * Split out so bun:test can cover the policy without a DOM (same pattern as
 * activity-feed-filters.ts). The tree used to key a useEffect on `groups` array
 * identity; any parent re-render that rebuilt that array — most visibly opening
 * the signal history panel — collapsed every open group.
 */
export function next_expanded_group_keys({
  search,
  previous_search,
  group_keys,
  expanded,
}: {
  search: string;
  previous_search: string;
  group_keys: readonly string[];
  expanded: ReadonlySet<string>;
}): Set<string> {
  const searching = search.trim().length > 0;
  const was_searching = previous_search.trim().length > 0;
  if (searching) return new Set(group_keys);
  if (was_searching) return new Set();
  return new Set(expanded);
}
